import React from 'react';
import DefaultCardKycButtonGroup from 'Components/shared/cards/DefaultCardKycButtonGroup';
import { i18nextKeys } from 'Lang/i18nextKeys';
import CustomButton from './CustomButton';

const AssetCardButtonGroup = ({
  openAssetInfo,
  openAssetModal,
  kycTier
}) => (
  <DefaultCardKycButtonGroup
    buttonConfig={{
      topButton: {
        show: true,
        label: {
          insufficientTier: i18nextKeys.buttonMoreDetails,
          sufficientTier: i18nextKeys.buttonMoreDetails
        },
        onClick: openAssetInfo
      },
      bottomButton: {
        show: false,
        label: {
          insufficientTier: i18nextKeys.kycGetTierToBuy,
          sufficientTier: i18nextKeys.buttonAddToCart
        },
        onClick: openAssetModal,
        origin: "asset tile"
      }
    }}
    requiredTier={kycTier}
    ButtonComponent={CustomButton}
    style={{
      gap: "10px",
      paddingLeft: "16px",
      paddingRight: "16px"
    }}
  />
);

export default AssetCardButtonGroup;
